import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle
} from '@angular/material/expansion';
import { ShouldShowContainerDetailsPipe } from '../../pipes/should-show-container-details.pipe';
import { AsyncPipe, DecimalPipe, UpperCasePipe } from '@angular/common';
import { catchError, map, NEVER, Subscription, tap } from 'rxjs';
import { Windward } from '../../models/windward';
import { MatDialog } from '@angular/material/dialog';
import { WindwardService } from '../../services/windward.service';
import { LiveTrackingComponent } from '../details/live-tracking/live-tracking.component';
import { UserService } from '../../../../services/user.service';
import { RouterLink } from '@angular/router';
import { ShouldShowContainersPipe } from '../../pipes/should-show-containers.pipe';
import { Shipment } from '../../../../pages/overview/models/shipment';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-containers',
  standalone: true,
  templateUrl: './containers.component.html',
  imports: [
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelTitle,
    MatExpansionPanelHeader,
    ShouldShowContainerDetailsPipe,
    UpperCasePipe,
    AsyncPipe,
    RouterLink,
    DecimalPipe,
    ShouldShowContainersPipe,
    MatProgressSpinner
  ],
  styleUrl: './containers.component.scss'
})
export class ContainersComponent implements OnChanges, OnDestroy {
  @Input() shipment: Shipment | null = null;
  @Input() isArchived = false;
  windwardLinksLoading = false;
  windwardLinks: Windward[] = [];
  private subscription = new Subscription();

  constructor(
    private dialog: MatDialog,
    private windwardService: WindwardService,
    private userService: UserService
  ) {}

  ngOnChanges() {
    this.getWindwardLinks();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  openLiveTracking(containerNo: string | null, gpsTracking?: string) {
    let customMapUrl = '';
    if (gpsTracking) {
      customMapUrl = gpsTracking;
    } else if (this.isTransportModeOcean()) {
      const windwardContainer = this.windwardLinks.find(el => el.containerNumber === containerNo);
      customMapUrl = windwardContainer ? windwardContainer.url : '';
    }
    this.dialog.open(LiveTrackingComponent, {
      height: '900px',
      width: '1300px',
      data: { containerNo, openCustomMap: !!gpsTracking || this.isTransportModeOcean(), customMapUrl }
    });
  }

  hasAccessToContainers() {
    return this.userService.getUserInfo().pipe(map(user => user.modules.includes('Containers')));
  }
  private getWindwardLinks() {
    if (this.isTransportModeOcean()) {
      this.windwardLinksLoading = true;
      this.subscription.add(
        this.windwardService
          .getMapLinksFor(this.shipment?.shipmentNo || '')
          .pipe(
            tap(res => {
              this.windwardLinks = res;
              this.windwardLinks.forEach(windwardContainer => {
                const shipContainer = this.shipment?.containers.find(
                  shipcontainer => shipcontainer.containerNo === windwardContainer.containerNumber
                );
                if (shipContainer && !!windwardContainer.url) {
                  shipContainer.isVaildURL = true;
                }
              });
              this.windwardLinksLoading = false;
            }),
            catchError(() => {
              this.windwardLinksLoading = false;
              return NEVER;
            })
          )
          .subscribe()
      );
    }
  }

  private isTransportModeOcean() {
    return this.shipment?.transportMode === 'Ocean';
  }
}
